import { getDroppedOrSelectedFiles } from "html5-file-selector";

export const getFilesFromEvent = (e: any): Promise<File[]> => {
  return new Promise(resolve => {
    getDroppedOrSelectedFiles(e).then((chosenFiles: any) => {
      resolve(chosenFiles.map((f: any) => f.fileObject))
    })
  })
};
